module.exports = __webpack_public_path__ + "static/media/zoleLose_50_75.c84efd64.png";